export default __webpack_public_path__ + "static/media/backImg.b2bf895d.jpg";